<template>
	<div class="post-status">
        <button  class="btn btn-tiny">Edit</button>
        <button  class="btn btn-tiny btn-delete">Delete</button>
	</div>
</template>

<script>
	export default {
		name: 'ColumnPostStatus',
		props: {
			rowData: {
				type: Object,
				required: true
			},
			rowIndex: {
				type: Number
			}
		},
		data () {
            return {}
        },
	}
</script>

<style lang="scss">
    @import "~@/_variables.scss";

    .btn{
        &.btn-delete{
            background: $accent--error;
            color: white;
        }
    }
</style>
